import { AmplifyService } from '@scorenco/core';

export const init = AmplifyService.init;
